import { apiClient } from '@/libs/api_client'
import axios from 'axios'
import {
  BatchUpdateUserRolePermissionsRequest,
  BatchUpdateUserRolePermissionsResponse,
} from '@magnetar/admin-api-interfaces'

interface BatchUpdateResult {
  success: boolean
  data?: { updated: number; failed: number } | null
  error?: {
    code: string
    message: string
  }
}

export const userRolePermissionService = {
  batchUpdatePermissions: async (
    data: BatchUpdateUserRolePermissionsRequest,
    token: string,
  ): Promise<BatchUpdateUserRolePermissionsResponse> => {
    try {
      const response = await apiClient.put<BatchUpdateUserRolePermissionsResponse>(
        '/api/user-role-permissions/batch',
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data as BatchUpdateUserRolePermissionsResponse
      }
      return {
        success: false,
        data: null,
        error: {
          code: 'UPDATE_USER_ROLE_PERMISSIONS_FAILED',
          message: '更新角色權限失敗',
        },
      }
    }
  },

  batchUpdateClinicPermissions: async (
    data: {
      user_role_id: number
      permissions: { module: string; allowed_action: string[] }[]
    },
    token: string,
  ): Promise<BatchUpdateResult> => {
    try {
      const response = await apiClient.put<BatchUpdateResult>(
        '/api/clinic-user-role-permissions/batch',
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data as BatchUpdateResult
      }
      return {
        success: false,
        data: null,
        error: {
          code: 'UPDATE_CLINIC_ROLE_PERMISSIONS_FAILED',
          message: '更新 Clinic 角色權限失敗',
        },
      }
    }
  },

  batchUpdateSupplierPermissions: async (
    data: {
      user_role_id: number
      permissions: { module: string; allowed_action: string[] }[]
    },
    token: string,
  ): Promise<BatchUpdateResult> => {
    try {
      const response = await apiClient.put<BatchUpdateResult>(
        '/api/supplier-user-role-permissions/batch',
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data as BatchUpdateResult
      }
      return {
        success: false,
        data: null,
        error: {
          code: 'UPDATE_SUPPLIER_ROLE_PERMISSIONS_FAILED',
          message: '更新 Supplier 角色權限失敗',
        },
      }
    }
  },

  batchUpdateProviderPermissions: async (
    data: {
      user_role_id: number
      permissions: { module: string; allowed_action: string[] }[]
    },
    token: string,
  ): Promise<BatchUpdateResult> => {
    try {
      const response = await apiClient.put<BatchUpdateResult>(
        '/api/provider-user-role-permissions/batch',
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data as BatchUpdateResult
      }
      return {
        success: false,
        data: null,
        error: {
          code: 'UPDATE_PROVIDER_ROLE_PERMISSIONS_FAILED',
          message: '更新 Provider 角色權限失敗',
        },
      }
    }
  },

  batchUpdateClinicGroupPermissions: async (
    data: {
      user_role_id: number
      permissions: { module: string; allowed_action: string[] }[]
    },
    token: string,
  ): Promise<BatchUpdateResult> => {
    try {
      const response = await apiClient.put<BatchUpdateResult>(
        '/api/clinic-group-user-role-permissions/batch',
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data as BatchUpdateResult
      }
      return {
        success: false,
        data: null,
        error: {
          code: 'UPDATE_CLINIC_GROUP_ROLE_PERMISSIONS_FAILED',
          message: '更新 Clinic Group 角色權限失敗',
        },
      }
    }
  },

  batchUpdateAdSupplierGroupPermissions: async (
    data: {
      user_role_id: number
      permissions: { module: string; allowed_action: string[] }[]
    },
    token: string,
  ): Promise<BatchUpdateResult> => {
    try {
      const response = await apiClient.put<BatchUpdateResult>(
        '/api/ad-supplier-group-user-role-permissions/batch',
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data as BatchUpdateResult
      }
      return {
        success: false,
        data: null,
        error: {
          code: 'UPDATE_AD_SUPPLIER_GROUP_ROLE_PERMISSIONS_FAILED',
          message: '更新 Ad Supplier Group 角色權限失敗',
        },
      }
    }
  },
}
